import { useState } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Sidebar from "../Dashboard/SideBar";
import Header from "./Header";

export default function Dashboard() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const hideHeader = location.pathname.startsWith("/dashboard/settings");

  return (
    <div className="min-h-screen bg-white flex">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />

      <div className="flex-1 min-w-0 lg:ml-[280px]">
        {!hideHeader && <Header setIsOpen={setSidebarOpen} />}

        <div
          className={`${
            hideHeader ? "pt-0" : "pt-[72px]"
          } bg-white min-h-screen px-4 md:px-6 py-4`}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
